const routes = {
  path: '/system',
  component: () => import('@/components/layout/index.vue'),
  alwaysShow: true,
  meta: {
    title: '系统管理',
    permission: 'system',
    icon: 'iconxitongshezhi_'
  },
  children: [
    {
      path: 'yun/smart',
      name: 'SmartSetting',
      component: () => import('@/views/system/yunSmart/index'),
      meta: {
        title: '小云智能',
        permission: 'system.yun',
      }
    },
    {
      path: 'bussiness/setting',
      name: 'BussinessSetting',
      component: () => import('@/views/system/bussinessSetting/index'),
      meta: {
        title: '业务设置',
        permission: 'system.business',
      }
    },
    {
      path: 'approve/setting',
      name: 'ApproveSetting',
      component: () => import('@/views/system/approveSetting/index'),
      meta: {
        title: '审批设置',
        permission: 'system.voucher',
      }
    },
    {
      path: 'approve/check-list',
      name: 'ApproveSettingList',
      component: () => import('@/views/system/approveSetting/settingList'),
      hidden: true,
      meta: {
        title: '审批设置',
        permission: 'system.voucher.process',
      }
    },
    {
      path: 'newhouse-card',
      name: 'NewHouseCard',
      component: () => import('@/views/system/houseCardSetting/index'),
      meta: {
        title: '云来客设置',
        permission: 'system.set',
      }
    },
    {
      path: 'operate-log',
      name: 'operateLog',
      component: () => import('@/views/system/logs/index'),
      meta: {
        title: '操作日志',
        permission: 'action-log',
      }
    }
  ]
}
export default routes;
